import { RouteObject } from 'react-router';

import { AdminSectionPagePermission, AdminSectionTemplate } from '@anyx/function-chat/shared';

import { AdminSectionPage } from './pages';

export const routes: RouteObject[] = [
  {
    path: 'admin-section',
    element: (
      <AdminSectionPagePermission>
        <AdminSectionTemplate />
      </AdminSectionPagePermission>
    ),
    children: [
      {
        index: true,
        element: <AdminSectionPage />,
      },
    ],
  },
];
